import {
  Alert, 
  AlertTitle,
  CardContent,
  Card,
  Grid,
  Typography,
  Link,
  CircularProgress,
} from "@mui/material";
import ResponsiveDrawer from "../components/ClippedResponsiveDrawer";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    centerDiv: {
      textAlign: "center",
      top: -150,
      position: "relative",
    },
    image: {
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    primary: {
      marginTop: theme.spacing(2),
      alignItems: 'center',
      justifyContent: 'center',
      top: `50%`,
      left: `50%`,
    },
  })
);



function IdentityBadge(props:{color?:string, fillColor?:string}){
  let color = props.color || "#000000"
  let fillColor = props.fillColor || "#ffffff"
  
  return (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="svg1" viewBox="0 20 60 40" version="1.0" y="0" x="0" >
      <path
          id="rect825"
          style={{
            strokeLinejoin:"round",
            fillRule:"evenodd",
            stroke:color,
            strokeLinecap:"round",
            strokeWidth:2.5,
            fill:fillColor,
          }}
          d="m6.4187 25.553c-1.1327 0-2.0446 0.911-2.0446 2.044v25.829c0 1.133 0.9119 2.045 2.0446 2.045h47.162c1.133 0 2.045-0.912 2.045-2.045v-25.829c0-1.133-0.912-2.044-2.045-2.044h-47.162z"
      />
      <path
          id="path827"
          style={{
            strokeLinejoin:"round",
            stroke:color,
            strokeLinecap:"round",
            strokeWidth:5,
            fill:"none",
          }}
          d="m35.744 31.449h13.747"
      />
      <path
          id="path828"
          style={{
            strokeLinejoin:"round",
            stroke:color,
            strokeLinecap:"round",
            strokeWidth:2.5,
            fill:"none",
          }}
          d="m34.494 38.144h11.187"
      />
      <path
          id="path852"
          style={{
            strokeLinejoin:"round",
            stroke:color,
            strokeLinecap:"round",
            strokeWidth:2.5,
            fill:"none",
          }}
          d="m34.398 42.371h15.622"
      />
      <path
          id="path853"
          style={{
            strokeLinejoin:"round",
            stroke:color,
            strokeLinecap:"round",
            strokeWidth:2.5,
            fill:"none",
          }}
          d="m34.494 46.598h8.049"
      />
      <path
          id="path2079"
          style={{
            strokeLinejoin:"round",
            stroke:color,
            strokeLinecap:"round",
            strokeWidth:2.5,
            fill:"none",
          }}
          d="m34.494 50.824h13.049"
      />
      <g
          id="g2859"
          transform="translate(-.11211 .11309)"
        >
        <path
            id="rect874"
            style={{
              fillRule:"evenodd",
              fill:fillColor,
            }}
            d="m11.655 29.774h16.189c1.402 0 2.531 1.164 2.531 2.609v16.031c0 1.446-1.129 2.61-2.531 2.61h-16.189c-1.402 0-2.5304-1.164-2.5304-2.61v-16.031c0-1.445 1.1284-2.609 2.5304-2.609z"
        />
        <g
            id="g2085"
            transform="matrix(1.0458 0 0 1.0458 -1.0113 -2.3697)"
          >
          <path
              id="path849"
              style={{
                strokeLinejoin:"round",
                fillRule:"evenodd",
                stroke:color,
                strokeLinecap:"round",
                strokeWidth:1.7929,
                fill:fillColor,
              }}
              d="m26.724 50.799c-0.709-2.062-1.672-4.083-3.445-5.183-1.875-0.081-4.244 0-6.527 0-1.931 1.028-3 3.07-3.773 5.183"
          />
          <path
              id="path716"
              style={{
                strokeLinejoin:"round",
                fillRule:"evenodd",
                stroke:color,
                strokeLinecap:"round",
                strokeWidth:1.7929,
                fill:fillColor,
              }}
              d="m25.79 40.781c0 3.279-2.66 5.939-5.938 5.939-3.279 0-5.939-2.66-5.939-5.939 0-3.278 2.66-5.938 5.939-5.938 3.278 0 5.938 2.66 5.938 5.938z"
          />
        </g>
        <path
            id="path2857"
            style={{
              stroke:color,
              strokeWidth:1.875,
              fill:"none",
            }}
            d="m11.655 29.774h16.189c1.402 0 2.531 1.164 2.531 2.609v16.031c0 1.446-1.129 2.61-2.531 2.61h-16.189c-1.402 0-2.5304-1.164-2.5304-2.61v-16.031c0-1.445 1.1284-2.609 2.5304-2.609z"
        />
      </g>
    </svg>
  );
}

export default function LoginSpinner() {
  const classes = useStyles();
  const theme = useTheme();
  return (
    <Grid container spacing={1} className={classes.primary}>
      <Grid item>
        <Card className={classes.primary}>
          <CardContent>
            <Alert severity="info">
              <AlertTitle>Logging into NextGen Vending</AlertTitle> 
            </Alert>
            <br/>
            <div className={classes.image} >
              <IdentityBadge color={theme.palette.statusRed.main} fillColor={theme.palette.action.disabledBackground} />
            </div>
            <div className={classes.centerDiv} >
              <CircularProgress color="primary" size={100} />
            </div>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};
